import {createApp} from '../libs/petite-vue.js';
import { Cart } from './components/cart.js';
import { AddToCart } from './components/add-to-cart.js';
import { AddVariationToCart } from './components/add-variation-to-cart.js';
import { Checkout } from './components/checkout.js';
import { CartIcon } from './components/cart-icon.js';
import { RotateLogo } from './components/rotate.js';
import { ShowMore } from './components/show-more.js';
import { store } from './components/store.js';

createApp({ Cart, AddToCart, AddVariationToCart, Checkout, CartIcon, RotateLogo, ShowMore }).mount();

//console.log('App initialized', store);